
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/anthropic-api-ui",
      function () {
        return require("private-next-pages/anthropic-api-ui.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/anthropic-api-ui"])
      });
    }
  